import DescriptionInput from "Components/Common/Input/TextBoxes/DescriptionInput/DescriptionInput";
import TitleInput from "Components/Common/Input/TextBoxes/TitleInput/TitleInput";
import MediaUpload from "Components/Common/MediaUpload/MediaUpload";
import ContentView from "Components/ContentView/ContentView";
import i18n from "i18next";
import { TaskTemplate } from "Models/Tasks/TaskTemplate";
import * as React from "react";
import styles from "./TaskTemplateInfo.scss";

interface IProps {
    taskTemplate: TaskTemplate;
    onChange?: (name: string, description: string, isMediaChanged: boolean, pictureFile?: File, videoFile?: File, videoThumbnailFile?: File) => void;
}

interface IState {
    name: string;
    description: string;
    taskTemplateId: number | undefined;
    isNameFocussed: boolean;
    isDescriptionFocussed: boolean;
    pictureFile?: File;
    videoFile?: File;
    videoThumbnailFile?: File;
    isMediaChanged: boolean;
}

export class TaskTemplateInfo extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            name: props.taskTemplate.name,
            description: props.taskTemplate.description,
            taskTemplateId: props.taskTemplate.id,
            isNameFocussed: false,
            isDescriptionFocussed: false,
            isMediaChanged: false
        };

        this.onNameChanged = this.onNameChanged.bind(this);
        this.onDescriptionChanged = this.onDescriptionChanged.bind(this);
        this.onMediaChanged = this.onMediaChanged.bind(this);
    }

    public onNameChanged(newValue: string) {
        this.setState({ name: newValue });

        if (this.props.onChange) {
            this.props.onChange(newValue, this.state.description, this.state.isMediaChanged, this.state.pictureFile, this.state.videoFile, this.state.videoThumbnailFile);
        }
    }

    public onDescriptionChanged(newValue: string) {
        this.setState({
            description: newValue
        });

        if (this.props.onChange) {
            this.props.onChange(this.state.name, newValue, this.state.isMediaChanged, this.state.pictureFile, this.state.videoFile, this.state.videoThumbnailFile);
        }
    }

    public onMediaChanged(state: { imageFile?: File, videoFile?: File, videoThumbnailFile?: File }): void {
        this.setState({ pictureFile: state.imageFile, videoFile: state.videoFile, videoThumbnailFile: state.videoThumbnailFile, isMediaChanged: true });

        if (this.props.onChange) {
            this.props.onChange(this.state.name, this.state.description, true, state.imageFile, state.videoFile, state.videoThumbnailFile);
        }
    }

    public static getDerivedStateFromProps(nextProps: IProps, prevState: IState): Partial<IState> {
        const partialState: Partial<IState> = {};

        if (nextProps.taskTemplate && nextProps.taskTemplate.id !== prevState.taskTemplateId) {
            partialState.taskTemplateId = nextProps.taskTemplate.id;
            partialState.name = nextProps.taskTemplate.name;
            partialState.description = nextProps.taskTemplate.description;
        }

        return partialState;
    }

    public render() {
        return (
            <ContentView>
                <div className={styles.taskTemplateInfo}>
                    <div className={styles.info}>
                        {this.props.taskTemplate.id ? (
                            <div id="divTaskTemplateId" className={styles.taskTemplateId}>{i18n.t("tasks.properties.taskId")}: {this.state.taskTemplateId}</div>
                        ) : (
                                <div className={styles.taskTemplateId}>{i18n.t("tasks.newTask")}</div>
                            )}
                        <TitleInput id="txtTaskTemplateName" value={this.state.name} onChange={this.onNameChanged} placeholder={i18n.t("tasks.placeholders.taskTitle")} />
                        <DescriptionInput id="txtTaskTemplateDescription" value={this.state.description} onChange={this.onDescriptionChanged} placeholder={i18n.t("tasks.placeholders.taskDescription")} />
                    </div>
                    <div className={styles.media}>
                        <MediaUpload
                            id="mduTaskTemplateMedia"
                            imageUrl={this.props.taskTemplate.pictureUrl}
                            videoUrl={this.props.taskTemplate.videoUrl}
                            videoThumbnailUrl={this.props.taskTemplate.videoThumbnailUrl}
                            onChange={this.onMediaChanged} />
                    </div>
                </div>
            </ContentView>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/Pages/TaskTemplateDetailView/TaskTemplateInfo/TaskTemplateInfo.tsx